// extracted by mini-css-extract-plugin
export default {"btnMain":"EditAnnouncement_btnMain__eI0Xn","users__list":"EditAnnouncement_users__list__7CcRG"};